/**
 * Profile and client form options - country codes, timezones, dietary options, etc.
 * Used by DashboardPage and other client/profile UIs.
 */

export const goalOptions = [
  { value: 'lose', labelHe: 'ירידה במשקל', labelEn: 'Lose Weight' },
  { value: 'cut', labelHe: 'CUT', labelEn: 'CUT' },
  { value: 'maintain', labelHe: 'שמירה על משקל', labelEn: 'Maintain Weight' },
  { value: 'gain', labelHe: 'עלייה במשקל', labelEn: 'Gain Weight' },
  { value: 'muscle', labelHe: 'בניית שרירים', labelEn: 'Build Muscle' },
  { value: 'improve_performance', labelHe: 'שיפור ביצועים', labelEn: 'Improve Performance' },
  { value: 'improve_health', labelHe: 'שיפור בריאות', labelEn: 'Improve Health' }
];

export const activityLevelOptions = [
  { value: 'sedentary', labelHe: 'יושבני - מעט או ללא פעילות גופנית', labelEn: 'Sedentary - Little or no exercise' },
  { value: 'light', labelHe: 'פעילות קלה - 1-3 פעמים בשבוע', labelEn: 'Light Activity - 1-3 days/week' },
  { value: 'moderate', labelHe: 'פעילות בינונית - 3-5 פעמים בשבוע', labelEn: 'Moderate Activity - 3-5 days/week' },
  { value: 'active', labelHe: 'פעיל - 6-7 פעמים בשבוע', labelEn: 'Active - 6-7 days/week' },
  { value: 'extreme', labelHe: 'קיצוני - פעילות אינטנסיבית/עבודה פיזית', labelEn: 'Extreme - Very hard exercise/physical job' }
];

export const countryCodes = [
  { code: '+1', country: '🇺🇸 US/CA', minLength: 10, maxLength: 10 },
  { code: '+44', country: '🇬🇧 UK', minLength: 10, maxLength: 10 },
  { code: '+49', country: '🇩🇪 Germany', minLength: 10, maxLength: 12 },
  { code: '+33', country: '🇫🇷 France', minLength: 9, maxLength: 9 },
  { code: '+39', country: '🇮🇹 Italy', minLength: 9, maxLength: 10 },
  { code: '+34', country: '🇪🇸 Spain', minLength: 9, maxLength: 9 },
  { code: '+31', country: '🇳🇱 Netherlands', minLength: 9, maxLength: 9 },
  { code: '+32', country: '🇧🇪 Belgium', minLength: 9, maxLength: 9 },
  { code: '+41', country: '🇨🇭 Switzerland', minLength: 9, maxLength: 9 },
  { code: '+43', country: '🇦🇹 Austria', minLength: 10, maxLength: 13 },
  { code: '+46', country: '🇸🇪 Sweden', minLength: 9, maxLength: 9 },
  { code: '+47', country: '🇳🇴 Norway', minLength: 8, maxLength: 8 },
  { code: '+45', country: '🇩🇰 Denmark', minLength: 8, maxLength: 8 },
  { code: '+358', country: '🇫🇮 Finland', minLength: 5, maxLength: 10 },
  { code: '+353', country: '🇮🇪 Ireland', minLength: 9, maxLength: 9 },
  { code: '+351', country: '🇵🇹 Portugal', minLength: 9, maxLength: 9 },
  { code: '+30', country: '🇬🇷 Greece', minLength: 10, maxLength: 10 },
  { code: '+972', country: '🇮🇱 Israel', minLength: 9, maxLength: 9 },
  { code: '+971', country: '🇦🇪 UAE', minLength: 9, maxLength: 9 },
  { code: '+7', country: '🇷🇺 Russia', minLength: 10, maxLength: 10 },
  { code: '+86', country: '🇨🇳 China', minLength: 11, maxLength: 11 },
  { code: '+81', country: '🇯🇵 Japan', minLength: 10, maxLength: 10 },
  { code: '+82', country: '🇰🇷 South Korea', minLength: 9, maxLength: 11 },
  { code: '+91', country: '🇮🇳 India', minLength: 10, maxLength: 10 },
  { code: '+61', country: '🇦🇺 Australia', minLength: 9, maxLength: 9 },
  { code: '+64', country: '🇳🇿 New Zealand', minLength: 8, maxLength: 10 },
  { code: '+27', country: '🇿🇦 South Africa', minLength: 9, maxLength: 9 },
  { code: '+55', country: '🇧🇷 Brazil', minLength: 10, maxLength: 11 },
  { code: '+52', country: '🇲🇽 Mexico', minLength: 10, maxLength: 10 },
  { code: '+54', country: '🇦🇷 Argentina', minLength: 10, maxLength: 10 },
  { code: '+60', country: '🇲🇾 Malaysia', minLength: 9, maxLength: 11 },
  { code: '+65', country: '🇸🇬 Singapore', minLength: 8, maxLength: 8 },
  { code: '+66', country: '🇹🇭 Thailand', minLength: 9, maxLength: 9 },
  { code: '+90', country: '🇹🇷 Turkey', minLength: 10, maxLength: 10 }
];

export const timezones = [
  { value: 'Asia/Jerusalem', label: '🇮🇱 Israel (Asia/Jerusalem)', offset: 'GMT+2/+3' },
  { value: 'Europe/London', label: '🇬🇧 London (Europe/London)', offset: 'GMT+0/+1' },
  { value: 'Europe/Paris', label: '🇫🇷 Paris (Europe/Paris)', offset: 'GMT+1/+2' },
  { value: 'Europe/Berlin', label: '🇩🇪 Berlin (Europe/Berlin)', offset: 'GMT+1/+2' },
  { value: 'Europe/Rome', label: '🇮🇹 Rome (Europe/Rome)', offset: 'GMT+1/+2' },
  { value: 'Europe/Madrid', label: '🇪🇸 Madrid (Europe/Madrid)', offset: 'GMT+1/+2' },
  { value: 'Europe/Amsterdam', label: '🇳🇱 Amsterdam (Europe/Amsterdam)', offset: 'GMT+1/+2' },
  { value: 'Europe/Brussels', label: '🇧🇪 Brussels (Europe/Brussels)', offset: 'GMT+1/+2' },
  { value: 'Europe/Zurich', label: '🇨🇭 Zurich (Europe/Zurich)', offset: 'GMT+1/+2' },
  { value: 'Europe/Vienna', label: '🇦🇹 Vienna (Europe/Vienna)', offset: 'GMT+1/+2' },
  { value: 'Europe/Stockholm', label: '🇸🇪 Stockholm (Europe/Stockholm)', offset: 'GMT+1/+2' },
  { value: 'Europe/Oslo', label: '🇳🇴 Oslo (Europe/Oslo)', offset: 'GMT+1/+2' },
  { value: 'Europe/Copenhagen', label: '🇩🇰 Copenhagen (Europe/Copenhagen)', offset: 'GMT+1/+2' },
  { value: 'Europe/Helsinki', label: '🇫🇮 Helsinki (Europe/Helsinki)', offset: 'GMT+2/+3' },
  { value: 'Europe/Dublin', label: '🇮🇪 Dublin (Europe/Dublin)', offset: 'GMT+0/+1' },
  { value: 'Europe/Lisbon', label: '🇵🇹 Lisbon (Europe/Lisbon)', offset: 'GMT+0/+1' },
  { value: 'Europe/Athens', label: '🇬🇷 Athens (Europe/Athens)', offset: 'GMT+2/+3' },
  { value: 'Europe/Moscow', label: '🇷🇺 Moscow (Europe/Moscow)', offset: 'GMT+3' },
  { value: 'Asia/Dubai', label: '🇦🇪 Dubai (Asia/Dubai)', offset: 'GMT+4' },
  { value: 'Asia/Shanghai', label: '🇨🇳 Shanghai (Asia/Shanghai)', offset: 'GMT+8' },
  { value: 'Asia/Tokyo', label: '🇯🇵 Tokyo (Asia/Tokyo)', offset: 'GMT+9' },
  { value: 'Asia/Seoul', label: '🇰🇷 Seoul (Asia/Seoul)', offset: 'GMT+9' },
  { value: 'Asia/Kolkata', label: '🇮🇳 Kolkata (Asia/Kolkata)', offset: 'GMT+5:30' },
  { value: 'Asia/Singapore', label: '🇸🇬 Singapore (Asia/Singapore)', offset: 'GMT+8' },
  { value: 'Asia/Bangkok', label: '🇹🇭 Bangkok (Asia/Bangkok)', offset: 'GMT+7' },
  { value: 'Asia/Kuala_Lumpur', label: '🇲🇾 Kuala Lumpur (Asia/Kuala_Lumpur)', offset: 'GMT+8' },
  { value: 'Asia/Istanbul', label: '🇹🇷 Istanbul (Asia/Istanbul)', offset: 'GMT+3' },
  { value: 'Australia/Sydney', label: '🇦🇺 Sydney (Australia/Sydney)', offset: 'GMT+10/+11' },
  { value: 'Australia/Melbourne', label: '🇦🇺 Melbourne (Australia/Melbourne)', offset: 'GMT+10/+11' },
  { value: 'Pacific/Auckland', label: '🇳🇿 Auckland (Pacific/Auckland)', offset: 'GMT+12/+13' },
  { value: 'Africa/Johannesburg', label: '🇿🇦 Johannesburg (Africa/Johannesburg)', offset: 'GMT+2' },
  { value: 'America/New_York', label: '🇺🇸 New York (America/New_York)', offset: 'GMT-5/-4' },
  { value: 'America/Chicago', label: '🇺🇸 Chicago (America/Chicago)', offset: 'GMT-6/-5' },
  { value: 'America/Denver', label: '🇺🇸 Denver (America/Denver)', offset: 'GMT-7/-6' },
  { value: 'America/Los_Angeles', label: '🇺🇸 Los Angeles (America/Los_Angeles)', offset: 'GMT-8/-7' },
  { value: 'America/Toronto', label: '🇨🇦 Toronto (America/Toronto)', offset: 'GMT-5/-4' },
  { value: 'America/Vancouver', label: '🇨🇦 Vancouver (America/Vancouver)', offset: 'GMT-8/-7' },
  { value: 'America/Mexico_City', label: '🇲🇽 Mexico City (America/Mexico_City)', offset: 'GMT-6/-5' },
  { value: 'America/Sao_Paulo', label: '🇧🇷 São Paulo (America/Sao_Paulo)', offset: 'GMT-3/-2' },
  { value: 'America/Buenos_Aires', label: '🇦🇷 Buenos Aires (America/Buenos_Aires)', offset: 'GMT-3' }
];

export const allergiesOptions = [
  { value: 'peanuts', labelHe: 'בוטנים', labelEn: 'Peanuts' },
  { value: 'tree_nuts', labelHe: 'אגוזי עץ', labelEn: 'Tree Nuts' },
  { value: 'milk', labelHe: 'חלב', labelEn: 'Milk/Dairy' },
  { value: 'eggs', labelHe: 'ביצים', labelEn: 'Eggs' },
  { value: 'wheat', labelHe: 'חיטה', labelEn: 'Wheat' },
  { value: 'soy', labelHe: 'סויה', labelEn: 'Soy' },
  { value: 'fish', labelHe: 'דגים', labelEn: 'Fish' },
  { value: 'seafood', labelHe: 'פירות ים', labelEn: 'Seafood' }
];

export const limitationsOptions = [
  { value: 'vegetarian', labelHe: 'צמחוני', labelEn: 'Vegetarian' },
  { value: 'vegan', labelHe: 'טבעוני', labelEn: 'Vegan' },
  { value: 'pescatarian', labelHe: 'פסקטריאני', labelEn: 'Pescatarian' },
  { value: 'kosher', labelHe: 'כשר', labelEn: 'Kosher' },
  { value: 'halal', labelHe: 'חלאל', labelEn: 'Halal' },
  { value: 'gluten_free', labelHe: 'ללא גלוטן', labelEn: 'Gluten-free' },
  { value: 'dairy_free', labelHe: 'ללא חלב', labelEn: 'Dairy-free' }
];

export const regions = [
  { value: 'israel', labelHe: 'ישראל', labelEn: 'Israel' },
  { value: 'japan', labelHe: 'יפן', labelEn: 'Japan' },
  { value: 'korea', labelHe: 'קוריאה', labelEn: 'Korea' },
  { value: 'greater_china', labelHe: 'סין/הונג קונג/טאיוואן', labelEn: 'Greater China' },
  { value: 'india_south_asia', labelHe: 'הודו / דרום אסיה', labelEn: 'India / South Asia' },
  { value: 'southeast_asia', labelHe: 'דרום־מזרח אסיה', labelEn: 'Southeast Asia' },
  { value: 'indonesia_malaysia', labelHe: 'אינדונזיה/מלזיה', labelEn: 'Indonesia/Malaysia' },
  { value: 'turkey', labelHe: 'טורקיה', labelEn: 'Turkey' },
  { value: 'persian_iranian', labelHe: 'איראן/פרס', labelEn: 'Persian/Iranian' },
  { value: 'gulf_arabia', labelHe: 'העולם הערבי-מפרץ', labelEn: 'Gulf Arabia' },
  { value: 'north_africa', labelHe: 'צפון אפריקה', labelEn: 'North Africa' },
  { value: 'east_africa', labelHe: 'אפריקה מזרחית', labelEn: 'East Africa' },
  { value: 'europe_mediterranean', labelHe: 'אירופה - ים תיכוני', labelEn: 'Europe - Mediterranean' },
  { value: 'europe_west', labelHe: 'אירופה - מרכז/מערב', labelEn: 'Europe - Central/West' },
  { value: 'europe_east_russian', labelHe: 'אירופה - מזרח/רוסי', labelEn: 'Europe - East/Russian' },
  { value: 'mexico', labelHe: 'אמריקה לטינית - מקסיקו', labelEn: 'Latin America - Mexico' },
  { value: 'latam_south_america', labelHe: 'אמריקה לטינית - דרום אמריקה', labelEn: 'Latin America - South America' },
  { value: 'caribbean', labelHe: 'קריביים', labelEn: 'Caribbean' },
  { value: 'north_america', labelHe: 'צפון אמריקה', labelEn: 'North America' },
  { value: 'other', labelHe: 'אחר', labelEn: 'Other' }
];

export const aiLanguages = [
  { value: 'en', label: 'English' }, { value: 'he', label: 'Hebrew (עברית)' },
  { value: 'es', label: 'Spanish' }, { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' }, { value: 'ar', label: 'Arabic' },
  { value: 'ru', label: 'Russian' }, { value: 'pt', label: 'Portuguese' },
  { value: 'it', label: 'Italian' }, { value: 'ja', label: 'Japanese' }
];

/** WhatsApp text when notifying a client that a new meal plan was activated (key = aiLanguages value). */
export const newMealPlanNotifyMessagesByLang = {
  en: 'You have a new meal plan! Ask me for more info.',
  he: 'יש לך תוכנית ארוחות חדשה! אפשר לשאול אותי לפרטים נוספים.',
  es: '¡Tienes un nuevo plan de comidas! Pregúntame si quieres más información.',
  fr: 'Vous avez un nouveau plan alimentaire ! Demandez-moi plus d’infos.',
  de: 'Du hast einen neuen Ernährungsplan! Frag mich gerne nach mehr Infos.',
  ar: 'لديك خطة وجبات جديدة! اسألني لمزيد من المعلومات.',
  ru: 'У вас новый план питания! Спрашивайте меня, если нужны подробности.',
  pt: 'Você tem um novo plano alimentar! Pergunte-me se quiser mais informações.',
  it: 'Hai un nuovo piano alimentare! Chiedimi per ulteriori informazioni.',
  ja: '新しい食事プランがあります！詳しくはお気軽にご質問ください。'
};

/**
 * @param {string | null | undefined} clientLang — `language` from client DB (e.g. en, he)
 * @returns {string}
 */
export function getNewMealPlanNotifyMessage(clientLang) {
  const code = String(clientLang || 'en')
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
  return newMealPlanNotifyMessagesByLang[code] || newMealPlanNotifyMessagesByLang.en;
}
